import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { LocalJsonStorage } from "../../../infra/http/local-json-storage";
import { AUTH_HEADER, AUTH_TOKEN_KEY, BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import Swal from "sweetalert2";
import { RejectCustomer } from "../../../domain/useages/customer-database/reject-customer";
import { RemoteRejectCustomer } from "../../../data/usecases/customer-database/remote-reject-customer";
import { CustomerDatabaseStore } from "../../main/CustomerDatabaseStore";

export interface RejectCustomerInterface {
  rejectCustomer: Function;
  handleRejectLoading: Function;
}

const initialStates = {};

const axiosHttpClient = AxiosHttpClient.getInstance();
const storage = LocalJsonStorage.getInstance();

export const useRejectCustomerSlice: StateCreator<RejectCustomerInterface> = (
  set,
  get
) => ({
  ...initialStates,
  handleRejectLoading: (value: boolean) => {
    if (value) {
      Swal.fire({
        didOpen: () => {
          if (value) {
            Swal.showLoading();
          }
        },
        customClass: {
          container: "swal2-style",
        },
        title: "Please wait... Reject customer request is sending ",
      });
    }
  },

  rejectCustomer: async (
    payload: RejectCustomer.Params,
    handleClose: Function,
    title: string,
    fetchCustomerData: Function,
    handleClearSelectedCustomers: Function,
    fetchCustomerSummaryCount: Function
  ) => {
    const token = storage.get(AUTH_TOKEN_KEY);
    const BASE_URL = storage.get(BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: atob(token),
    });
    const remoteRejectCustomer: RejectCustomer = new RemoteRejectCustomer(
      `${BASE_URL}${Endpoints.REJECT_CUSTOMER}`,

      axiosHttpClient
    );
    get().handleRejectLoading(true);
    let response = await remoteRejectCustomer.update(payload);

    if (response && response.success) {
      get().handleRejectLoading(false);
      fetchCustomerData();
      handleClearSelectedCustomers();
      fetchCustomerSummaryCount(CustomerDatabaseStore.getState().filterStore);
      Swal.fire({
        icon: "success",
        title: response.message,
        timer: 3000,
        customClass: {
          container: "swal2-style",
        },
      });
      handleClose(title);
    } else {
      get().handleRejectLoading(false);
      Swal.fire("Reject customer request failed", "", "error");
    }
  },
});
